'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (Navigation, $) {
		'use strict';

		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.promoBar = $('[data-promo-bar]');
			$dom.closePromo = $('[data-close-promo]');
			$dom.mobileTrigger = $('[data-mobile-trigger]');
			$dom.mobileDrawer = $('[data-mobile-drawer]');
			$dom.navigation = $('[data-navigation]');
			$dom.header = $('[data-header]');

			$dom.mobileSubnavlink = $('[data-mobile-subnav-link]');
			$dom.mobileSubnav = $('[data-mobile-subnav]');
		};

		var navPageScroll = function navPageScroll() {
			if (window.location.href.indexOf("the-good") > -1) {
				if (window.location.hash) {
					var hash = window.location.hash;
					$('html, body').animate({
						scrollTop: $(hash).offset().top - 110
					}, 500);
					return false;
				}
			}
		};

		var navScroll = function navScroll() {
			$(document).on('click', '.nav-desktopChild__link , .nav-mobileChild__link ', function (event) {
				var headerHeight = $dom.header.outerHeight();
				if (this.hash !== "") {
					if (window.location.href.indexOf("the-good") > -1) {
						closeMobileNav();
						event.preventDefault();
						var hash = this.hash;
						//var test = $(hash).offset().top - headerHeight

						if (document.documentElement.clientWidth < 768) {
							$('html, body').animate({
								scrollTop: $(hash).offset().top + 150
							}, 500);
						} else {
							$('html, body').animate({
								scrollTop: $(hash).offset().top - headerHeight
							}, 500);
						}
					}
				} // End if
			});
		};

		var transparentHeader = function transparentHeader() {
			if ($(window).scrollTop() > 100) {
				$dom.navigation.addClass('is-opaque');
				$dom.promoBar.addClass('is-opaque');
				$dom.navigation.addClass('is-subnav');
			} else {
				if ($("body").hasClass("template__product")) {
					$dom.navigation.removeClass('is-subnav');
				} else if ($("body").hasClass("template__page--charity")) {
					$dom.navigation.removeClass('is-subnav');
				} else if ($("body").hasClass("template__product--pdp-combo")) {
					$dom.navigation.removeClass('is-subnav');
				} else {
					$dom.navigation.removeClass('is-opaque');
					$dom.promoBar.removeClass('is-opaque');
				}
			}
		};

		var openMobileNav = function openMobileNav() {
			var navHeight = $dom.header.outerHeight();
			$dom.navigation.addClass('is-open');
			$dom.promoBar.addClass('is-opaque');
			window.Scroll.lock();
			$dom.mobileDrawer.css('top', navHeight);
		};

		var closeMobileNav = function closeMobileNav() {
			if ($("body").hasClass("template__product") || $("body").hasClass("template__product--pdp-combo")) {} else {
				$dom.promoBar.removeClass('is-opaque');
			}
			$dom.navigation.removeClass('is-open');
			window.Scroll.unlock();
		};

		var toggleMobileNav = function toggleMobileNav() {
			if ($dom.navigation.hasClass('is-open')) {
				closeMobileNav();
			} else {
				openMobileNav();
			}
		};

		var bindUIActions = function bindUIActions() {

			$dom.mobileTrigger.on('click', function (event) {
				event.preventDefault();
				toggleMobileNav();
			});

			$dom.closePromo.on('click', function (event) {
				$dom.promoBar.hide();
				var navHeight = $dom.header.outerHeight();
				$dom.mobileDrawer.css('top', navHeight);
			});

			$dom.mobileSubnavlink.on('click', function (event) {
				$(this).toggleClass('is-open');
				$(this).closest('.nav-mobile__menu-item').find('.nav-mobileChild').slideToggle();
				return false;
			});

			$(window).on('resize', function () {
				if ($(window).width() >= 1024) {
					closeMobileNav();
				}
			});

			$(window).on('scroll', function () {
				transparentHeader();
			});

			$(window).on('resize', function () {
				transparentHeader();
			});
		};

		Navigation.init = function () {
			console.log('init');
			cacheDom();
			bindUIActions();
			//navPageScroll();
			navScroll();
			transparentHeader();
		};
	})(window.Navigation = window.Navigation || {}, _jquery2.default);
};